<template>
  <pt-detection-corpus-structure-update class="pt-detection-corpus-structure-update__page"></pt-detection-corpus-structure-update>
</template>

<script>
import PtDetectionCorpusStructureUpdate from 'cps/gene-product/pt-detection-corpus-structure-update/withData'
export default {
  name: 'pt-detection-corpus-structure-update__view',
  components: {
    'pt-detection-corpus-structure-update': PtDetectionCorpusStructureUpdate
  }
}
</script>
